import React from 'react'
import IconButton from '@material-ui/core/IconButton';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';

const FavoriteIndicator = ({meal, setFavorite}) => {
    return (
        <div>
            <IconButton onClick={() => { setFavorite(meal, !meal.isFavorite)}}>
                {meal.isFavorite? <FavoriteIcon ></FavoriteIcon> : <FavoriteBorderIcon ></FavoriteBorderIcon>}
            </IconButton>
        </div>
        )
}

export default FavoriteIndicator
